import React from "react";
import { useNavigate } from "react-router-dom";

// Compoents
import Layout from "@/components/layout";
import StaffCard from "@/components/staffCard";
import Title from "@/components/title";
// import { SearchingBar, EscapeRegExp } from "@/components/searchingBar";

// Fetch
import { editStockOnHandList, getSohList } from "@/fetch/fetchStock";

// Mui
import Grid from "@mui/material/Grid2";

// Config
import { exportCSVFile } from "@/config/csvConfig";

// Moment
import moment from "moment";
import "moment/locale/zh-hk";

const SohManagePage = (props) => {
  const { open, setOpen } = props;

  // State
  const [loading, setLoading] = React.useState(false);
  const [sohListData, setSohListData] = React.useState([]);
  const [snackMessage, setSnackMessage] = React.useState("");
  const [snackOpen, setSnackOpen] = React.useState(false);

  const navigate = useNavigate();
  const fileReader = new FileReader();

  const handleDownloadCsv = async () => {
    var headers = {
      id: "id".replace(/,/g, ""),
      full_name: "full_name",
      staff_code: "staff_code",
      user_id: "user_id",
      giveaway_master_item_id: "giveaway_master_item_id",
      m18_product_code: "m18_product_code",
      item_name: "item_name",
      stockonhand_qty: "stockonhand_qty",
      adjust_qty: "adjust_qty",
      remark: "remark",
    };

    if (!loading) {
      setLoading(true);

      exportCSVFile(
        headers,
        sohListData,
        `SOH Setting - ${moment().format("YYYY-MM-DD")}`
      );
      setLoading(false);
    }
  };

  const fetchAll = async () => {
    await getSohList().then((data) => {
      if (data && data.results) {
        setSohListData(data.data);
      }
    });
  };

  const handleOnChangeUpload = (e) => {
    e.preventDefault();

    const file = e.target.files[0];

    if (file) {
      fileReader.onload = async function (event) {
        const text = event.target.result;

        const quoteChar = '"';
        const delimiter = ",";

        const regex = new RegExp(
          `\\s*(${quoteChar})?(.*?)\\1\\s*(?:${delimiter}|$)`,
          "gs"
        );

        const match = (line) =>
          [...line.matchAll(regex)]
            .map((m) => m[2]) // we only want the second capture group
            .slice(0, -1); // cut off blank match at the end

        var lines = text.split("\n");
        var result = [];

        // Read first row and display first column
        // var readVersion = lines[0].split(",");
        // var version = readVersion[0];

        var headers = match(lines.shift());
        // var headers = lines[1].split(",");
        // for (let i = 0; i < headers.length; i++) {
        //   headers[i] = headers[i].replace(`\r`, "");
        // }

        // Rows, skip 0
        for (var i = 0; i < lines.length; i++) {
          var obj = {};
          var currentline = match(lines[i]);

          // Columns
          for (var j = 0; j < headers.length; j++) {
            if (currentline[j] !== "" && currentline[j] !== undefined) {
              obj[headers[j]] = currentline[j];
            }
          }
          if (Number(obj.adjust_qty > 0) || Number(obj.adjust_qty < 0)) {
            result.push({ ...obj, reason_id: "999" });
          }
        }

        // Output
        await editStockOnHandList(result).then((data) => {
          if (data.results) {
            setSnackMessage(`上傳成功`);
          } else {
            setSnackMessage(`上傳失敗`);
          }
          setSnackOpen(true);
          setTimeout(() => {
            setSnackOpen(false);
          }, 3000);
        });
        fetchAll();
      };

      fileReader.readAsText(file);
    }
    e.target.value = null;
  };

  React.useEffect(() => {
    fetchAll();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Layout
      header="SohManagePage"
      selectedIndex={10}
      snackOpen={snackOpen}
      snackClose={() => setSnackOpen(false)}
      snackMessage={snackMessage}
      open={open}
      setOpen={setOpen}
    >
      <Title title={`倉存管理`} history={() => navigate(-1)} />
      <Grid container spacing={2} sx={{ height: "80vh" }}>
        <Grid
          size={{
            xs: 12,
            sm: 6,
            md: 6,
            lg: 3
          }}>
          <StaffCard
            download={true}
            type={"refill"}
            disable={sohListData.length < 0 ? true : undefined}
            displayName={`下載清單`}
            onClickDownload={() => handleDownloadCsv()}
          />
        </Grid>
        <Grid
          size={{
            xs: 12,
            sm: 6,
            md: 6,
            lg: 3
          }}>
          <StaffCard
            upload={true}
            type={"refill"}
            displayName={"更新倉存"}
            onChangeUpload={(e) => handleOnChangeUpload(e)}
          />
        </Grid>
      </Grid>
    </Layout>
  );
};

export default SohManagePage;
